import { PlusCircleOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React from 'react'
import { TEXT_CONSTANTS } from '../../../constants/Constants'

function AddButton({onClick}) {
 
  return (
    <div>
    <Button onClick={onClick} type="text" className="h-[27px] text-[#014D4E] bg-[rgba(1,77,78,0.3)] w-[65px] text-[10px] font-bold">
    <PlusCircleOutlined className='text-[#014D4E] text-[15px]'/>{TEXT_CONSTANTS.ADD}</Button>
    </div>
  )
}

export default AddButton
